<div class="settings-page">
    <div class="settings-page__content">
        <div class="settings-card">
            <div class="settings-card__header">
                <img src="/assets/images/Group 24.svg" alt="" />
                <div class="settings-card__header-headline">
                    <h2>Bine ați venit!</h2>
                    <h4>Setări - Documente</h4>
                </div>
            </div>
        </div>
    </div>

    <div class="content-box">
        <div class="settings-page-container">
            <mat-button-toggle-group [value]="selectedComponent" (change)="onChange($event)" class="settings-page_menu">
                <mat-button-toggle [value]="option" class="settings-page_menu-item"
                    *ngFor="let option of componentKeys">
                    <div style="text-align: left;">
                        {{ option }}
                    </div>
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        <div class="settings-page__content">
            <ng-container *ngIf="selectedComponent === SettingsActivitiesDocsOption.DOCUMENT_STATUSES">
                <app-document-statuses></app-document-statuses>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesDocsOption.DOCUMENT_PRIORITIES">
                <app-document-priorities></app-document-priorities>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesDocsOption.DOCUMENT_CATEGORIES">
                <app-document-categories></app-document-categories>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesDocsOption.DOCUMENT_TAGS">
                <app-document-tags></app-document-tags>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesDocsOption.DOCUMENT_TYPE">
                <app-document-type></app-document-type>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesDocsOption.DOCUMENT_SECTIONS">
                <app-document-sections></app-document-sections>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesDocsOption.EVENIMENT_GENEALOGIC_TYPE">
                <app-eveniment-genealogic></app-eveniment-genealogic>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesDocsOption.CONDITIE_MEDICALA_TYPE">
                <app-conditie-medicala></app-conditie-medicala>
            </ng-container>
            <div class="row" *ngIf="selectedComponent == null">
                <div class="col-sm-12 py-5">
                    <div class="row h-100 justify-content-center align-items-center">
                        <div class="col-12 text-center">
                            <div class="py-3">
                                <p class="mb-0">Selectați o secțiune</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>